$(function () {
	var index = {
		toast: function toast() {
			$('.close_ly').click(function () {
				$('.leyu_yspd,.toumingbi_yspd').hide()
			})
			$('.zixun').click(function () {
				$('.leyu_yspd,.toumingbi_yspd').show()
			})
		},
		yuyue: function yuyue() {
			$('.guanbi').click(function () {
				$('.form').hide()
			})
			$('.select-one .option').click(function () {
				var _this = $(this)

				_this.parent().prev().text(_this.text())

				$('.couse01').val(_this.text())
			})
			$('.select-city .option').click(function () {
				var _this = $(this)

				_this.parent().prev().text(_this.text())

				$('.city03').val(_this.text())
			})
			$('.form').listenForm({
				siteId: 55,
				contentName: '品宣在线报名',
				submitTarget: '#submitBtn2',
				cityRequired: true,
			})
		},
		map: function () {
			let schoolMap = {
				schoolArr: [],
				map: null,
				address: function address(idx) {
					schoolMap.map = new BMap.Map('school-map') // 创建Map实例
					schoolMap.map.centerAndZoom('天津', 12)
					schoolMap.map.enableScrollWheelZoom(true) //开启鼠标滚轮缩放
					//创建小图标
					let myIcon = new BMap.Icon(
						'http://webms1.xhd.cn/r/cms/resource2019/img/zb.png',
						new BMap.Size(20, 20)
					)
					function addMarkerWindow(item) {
						let pt = new BMap.Point(item.zuoBiaoX, item.zuoBiaoY)
						let marker2 = new BMap.Marker(pt, { icon: myIcon }) // 创建标注
						schoolMap.map.addOverlay(marker2)
						schoolMap.openWindow(item, pt, schoolMap.map)
					}
					addMarkerWindow(schoolMap.schoolArr[idx])
				},
				openWindow: function openWindow(item, pt, map) {
					let content = `
              <div class="mapWindow-box clearfix">
                <div  class="mapWindow-left">地址: ${item.description} <br/>电话：${item.author}</div>
              </div>
            `
					let titles = `<div class="mapWindow-title">${item.title}</div>`
					let searchInfoWindow = null
					searchInfoWindow = new BMap.InfoWindow(content, {
						title: titles,
						width: 264,
						height: 40,
						panel: 'panel', //检索结果面板
						enableAutoPan: true, //自动平移
					})
					map.openInfoWindow(searchInfoWindow, pt) // 打开信息窗口
				},
				init: function init(schoolArr) {
					schoolMap.schoolArr = schoolArr
					schoolMap.address(0)
					$(document).on('click', '.choose_bItem', function () {
						let _this = $(this)
						_this.addClass('cur').siblings().removeClass('cur')
						var idx = _this.index()
						schoolMap.address(idx)
						_this
							.closest('.choose')
							.find('.schoolbox')
							.eq(idx)
							.show()
							.siblings()
							.hide()
					})
				},
			}
			let schoolArr = [
				{
					zuoBiaoY: '39.11848',
					description: '天津市和平区贵州路18号君悦10层1008',
					zuoBiaoX: '117.20022',
					title: '一中校区',
					author: '400-011-8885',
				},
				{
					zuoBiaoY: '39.12331',
					description: '天津市和平区南京路181号世纪都会20-21层',
					zuoBiaoX: '117.205903',
					title: '营口道校区',
					author: '400-011-8885',
				},
			]

			schoolMap.init(schoolArr)
		},
		init: function init() {
			this.toast()
			this.yuyue()
			this.map()
		},
	}
	index.init()
})
